{
  "schemaVersion": "0.3.0",
  "dataset": {
    "id": "dataset_representative_models",
    "name": "Representative cross-sector financial models",
    "description": "Synthetic SaaS and bank fixtures for deterministic schema, validator, query, and visualization tests. Not investment research.",
    "createdAt": "2025-03-15T09:08:00Z",
    "updatedAt": "2025-03-15T09:08:00Z",
    "defaultModelId": "model_northstar_cloud"
  },
  "models": [
    {
      "id": "model_northstar_cloud",
      "name": "Northstar Cloud Operating Model",
      "description": "Representative SaaS model used to prove metric hierarchy and formula lineage.",
      "primaryEntityId": "entity_northstar_cloud",
      "baseCurrency": "USD",
      "asOf": "2025-03-15",
      "currentVersionId": "version_northstar_2025_03_15",
      "versionIds": [
        "version_northstar_2025_03_15"
      ],
      "defaultScenarioId": "scenario_base",
      "attributes": {
        "sector": "Software",
        "fiscalYearEnd": "December"
      }
    },
    {
      "id": "model_harbor_national",
      "name": "Harbor National Bank Model",
      "description": "Structurally different bank fixture used to test schema and viewer generality.",
      "primaryEntityId": "entity_harbor_national",
      "baseCurrency": "USD",
      "asOf": "2025-03-15",
      "currentVersionId": "version_harbor_2025_03_15",
      "versionIds": [
        "version_harbor_2025_03_15"
      ],
      "defaultScenarioId": "scenario_base",
      "attributes": {
        "sector": "Banks",
        "fiscalYearEnd": "December"
      }
    }
  ],
  "entities": [
    {
      "id": "entity_northstar_cloud",
      "type": "company",
      "name": "Northstar Cloud",
      "attributes": {
        "ticker": "NSTC"
      }
    },
    {
      "id": "entity_harbor_national",
      "type": "company",
      "name": "Harbor National",
      "attributes": {
        "ticker": "HBNK"
      }
    }
  ],
  "metrics": [
    {
      "id": "metric_northstar_revenue",
      "name": "Revenue",
      "description": "Total recognized revenue.",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement",
        "key-output"
      ]
    },
    {
      "id": "metric_northstar_subscription_revenue",
      "name": "Subscription revenue",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement",
        "driver"
      ]
    },
    {
      "id": "metric_northstar_services_revenue",
      "name": "Services revenue",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement"
      ]
    },
    {
      "id": "metric_northstar_cost_of_revenue",
      "name": "Cost of revenue",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement"
      ]
    },
    {
      "id": "metric_northstar_gross_profit",
      "name": "Gross profit",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement",
        "key-output"
      ]
    },
    {
      "id": "metric_northstar_gross_margin",
      "name": "Gross margin",
      "dataType": "percentage",
      "unit": "%",
      "aggregation": "average",
      "tags": [
        "margin",
        "key-output"
      ]
    },
    {
      "id": "metric_harbor_operating_income",
      "name": "Total operating income",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement",
        "key-output"
      ]
    },
    {
      "id": "metric_harbor_net_interest_income",
      "name": "Net interest income",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "banking",
        "driver"
      ]
    },
    {
      "id": "metric_harbor_non_interest_income",
      "name": "Non-interest income",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "banking"
      ]
    },
    {
      "id": "metric_harbor_provision",
      "name": "Provision for credit losses",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "credit",
        "assumption"
      ]
    },
    {
      "id": "metric_harbor_non_interest_expense",
      "name": "Non-interest expense",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "banking"
      ]
    },
    {
      "id": "metric_harbor_pre_tax_income",
      "name": "Pre-tax income",
      "dataType": "currency",
      "unit": "USDm",
      "aggregation": "sum",
      "tags": [
        "income-statement",
        "key-output"
      ]
    }
  ],
  "periods": [
    {
      "id": "period_fy2022",
      "label": "FY22A",
      "type": "fiscal_year",
      "startDate": "2022-01-01",
      "endDate": "2022-12-31"
    },
    {
      "id": "period_fy2023",
      "label": "FY23A",
      "type": "fiscal_year",
      "startDate": "2023-01-01",
      "endDate": "2023-12-31"
    },
    {
      "id": "period_fy2024",
      "label": "FY24A",
      "type": "fiscal_year",
      "startDate": "2024-01-01",
      "endDate": "2024-12-31"
    },
    {
      "id": "period_fy2025",
      "label": "FY25E",
      "type": "fiscal_year",
      "startDate": "2025-01-01",
      "endDate": "2025-12-31"
    },
    {
      "id": "period_fy2026",
      "label": "FY26E",
      "type": "fiscal_year",
      "startDate": "2026-01-01",
      "endDate": "2026-12-31"
    }
  ],
  "scenarios": [
    {
      "id": "scenario_actual",
      "name": "Actual",
      "type": "actual"
    },
    {
      "id": "scenario_base",
      "name": "Base",
      "type": "base"
    }
  ],
  "observationSeries": [
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_revenue",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_revenue_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1000,
          "valueType": "derived",
          "transformationId": "transformation_northstar_revenue"
        },
        {
          "id": "obs_northstar_revenue_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1150,
          "valueType": "derived",
          "transformationId": "transformation_northstar_revenue"
        },
        {
          "id": "obs_northstar_revenue_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1330,
          "valueType": "derived",
          "transformationId": "transformation_northstar_revenue"
        },
        {
          "id": "obs_northstar_revenue_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1535,
          "valueType": "derived",
          "transformationId": "transformation_northstar_revenue"
        },
        {
          "id": "obs_northstar_revenue_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1745,
          "valueType": "derived",
          "transformationId": "transformation_northstar_revenue"
        }
      ]
    },
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_subscription_revenue",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_subscription_revenue_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 820,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_subscription_revenue_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 960,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_subscription_revenue_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1125,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_subscription_revenue_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1315,
          "valueType": "assumption"
        },
        {
          "id": "obs_northstar_subscription_revenue_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1510,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_services_revenue",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_services_revenue_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 180,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_services_revenue_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 190,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_services_revenue_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 205,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_services_revenue_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 220,
          "valueType": "assumption"
        },
        {
          "id": "obs_northstar_services_revenue_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 235,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_cost_of_revenue",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_cost_of_revenue_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 340,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_cost_of_revenue_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 380,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_cost_of_revenue_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 425,
          "valueType": "reported"
        },
        {
          "id": "obs_northstar_cost_of_revenue_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 480,
          "valueType": "assumption"
        },
        {
          "id": "obs_northstar_cost_of_revenue_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 535,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_gross_profit",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_gross_profit_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 660,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_profit"
        },
        {
          "id": "obs_northstar_gross_profit_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 770,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_profit"
        },
        {
          "id": "obs_northstar_gross_profit_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 905,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_profit"
        },
        {
          "id": "obs_northstar_gross_profit_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1055,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_profit"
        },
        {
          "id": "obs_northstar_gross_profit_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1210,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_profit"
        }
      ]
    },
    {
      "modelId": "model_northstar_cloud",
      "metricId": "metric_northstar_gross_margin",
      "entityId": "entity_northstar_cloud",
      "asOf": "2025-03-15",
      "versionId": "version_northstar_2025_03_15",
      "points": [
        {
          "id": "obs_northstar_gross_margin_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 0.66,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_margin"
        },
        {
          "id": "obs_northstar_gross_margin_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 0.669565,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_margin"
        },
        {
          "id": "obs_northstar_gross_margin_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 0.680451,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_margin"
        },
        {
          "id": "obs_northstar_gross_margin_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 0.687296,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_margin"
        },
        {
          "id": "obs_northstar_gross_margin_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 0.69341,
          "valueType": "derived",
          "transformationId": "transformation_northstar_gross_margin"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_operating_income",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_operating_income_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 2000,
          "valueType": "derived",
          "transformationId": "transformation_harbor_operating_income"
        },
        {
          "id": "obs_harbor_operating_income_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 2080,
          "valueType": "derived",
          "transformationId": "transformation_harbor_operating_income"
        },
        {
          "id": "obs_harbor_operating_income_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 2175,
          "valueType": "derived",
          "transformationId": "transformation_harbor_operating_income"
        },
        {
          "id": "obs_harbor_operating_income_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 2275,
          "valueType": "derived",
          "transformationId": "transformation_harbor_operating_income"
        },
        {
          "id": "obs_harbor_operating_income_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 2375,
          "valueType": "derived",
          "transformationId": "transformation_harbor_operating_income"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_net_interest_income",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_net_interest_income_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1480,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_net_interest_income_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1540,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_net_interest_income_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1610,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_net_interest_income_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1685,
          "valueType": "assumption"
        },
        {
          "id": "obs_harbor_net_interest_income_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1760,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_non_interest_income",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_non_interest_income_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 520,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_income_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 540,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_income_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 565,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_income_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 590,
          "valueType": "assumption"
        },
        {
          "id": "obs_harbor_non_interest_income_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 615,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_provision",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_provision_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 210,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_provision_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 260,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_provision_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 225,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_provision_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 235,
          "valueType": "assumption"
        },
        {
          "id": "obs_harbor_provision_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 245,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_non_interest_expense",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_non_interest_expense_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1190,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_expense_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1230,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_expense_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 1285,
          "valueType": "reported"
        },
        {
          "id": "obs_harbor_non_interest_expense_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1330,
          "valueType": "assumption"
        },
        {
          "id": "obs_harbor_non_interest_expense_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 1380,
          "valueType": "assumption"
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "metricId": "metric_harbor_pre_tax_income",
      "entityId": "entity_harbor_national",
      "asOf": "2025-03-15",
      "versionId": "version_harbor_2025_03_15",
      "points": [
        {
          "id": "obs_harbor_pre_tax_income_fy2022",
          "periodId": "period_fy2022",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 600,
          "valueType": "derived",
          "transformationId": "transformation_harbor_pre_tax_income"
        },
        {
          "id": "obs_harbor_pre_tax_income_fy2023",
          "periodId": "period_fy2023",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 590,
          "valueType": "derived",
          "transformationId": "transformation_harbor_pre_tax_income"
        },
        {
          "id": "obs_harbor_pre_tax_income_fy2024",
          "periodId": "period_fy2024",
          "scenarioId": "scenario_actual",
          "actuality": "actual",
          "value": 665,
          "valueType": "derived",
          "transformationId": "transformation_harbor_pre_tax_income"
        },
        {
          "id": "obs_harbor_pre_tax_income_fy2025",
          "periodId": "period_fy2025",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 710,
          "valueType": "derived",
          "transformationId": "transformation_harbor_pre_tax_income"
        },
        {
          "id": "obs_harbor_pre_tax_income_fy2026",
          "periodId": "period_fy2026",
          "scenarioId": "scenario_base",
          "actuality": "estimate",
          "value": 750,
          "valueType": "derived",
          "transformationId": "transformation_harbor_pre_tax_income"
        }
      ]
    }
  ],
  "transformations": [
    {
      "id": "transformation_northstar_revenue",
      "outputMetricId": "metric_northstar_revenue",
      "expression": "sum(ref(\"metric_northstar_subscription_revenue\"), ref(\"metric_northstar_services_revenue\"))",
      "sourceExpressions": {
        "period_fy2022": "=SUM(B11:B12)",
        "period_fy2023": "=SUM(C11:C12)",
        "period_fy2024": "=SUM(D11:D12)",
        "period_fy2025": "=SUM(E11:E12)",
        "period_fy2026": "=SUM(F11:F12)"
      },
      "status": "supported"
    },
    {
      "id": "transformation_northstar_gross_profit",
      "outputMetricId": "metric_northstar_gross_profit",
      "expression": "ref(\"metric_northstar_revenue\") - ref(\"metric_northstar_cost_of_revenue\")",
      "sourceExpressions": {
        "period_fy2022": "=B10-B16",
        "period_fy2023": "=C10-C16",
        "period_fy2024": "=D10-D16",
        "period_fy2025": "=E10-E16",
        "period_fy2026": "=F10-F16"
      },
      "status": "supported"
    },
    {
      "id": "transformation_northstar_gross_margin",
      "outputMetricId": "metric_northstar_gross_margin",
      "expression": "when(ref(\"metric_northstar_revenue\") == 0, null, ref(\"metric_northstar_gross_profit\") / ref(\"metric_northstar_revenue\"))",
      "sourceExpressions": {
        "period_fy2022": "=IFERROR(B18/B10,0)",
        "period_fy2023": "=IFERROR(C18/C10,0)",
        "period_fy2024": "=IFERROR(D18/D10,0)",
        "period_fy2025": "=IFERROR(E18/E10,0)",
        "period_fy2026": "=IFERROR(F18/F10,0)"
      },
      "status": "supported"
    },
    {
      "id": "transformation_harbor_operating_income",
      "outputMetricId": "metric_harbor_operating_income",
      "expression": "sum(ref(\"metric_harbor_net_interest_income\"), ref(\"metric_harbor_non_interest_income\"))",
      "sourceExpressions": {
        "period_fy2022": "=SUM(B9:B10)",
        "period_fy2023": "=SUM(C9:C10)",
        "period_fy2024": "=SUM(D9:D10)",
        "period_fy2025": "=SUM(E9:E10)",
        "period_fy2026": "=SUM(F9:F10)"
      },
      "status": "supported"
    },
    {
      "id": "transformation_harbor_pre_tax_income",
      "outputMetricId": "metric_harbor_pre_tax_income",
      "expression": "ref(\"metric_harbor_operating_income\") - ref(\"metric_harbor_provision\") - ref(\"metric_harbor_non_interest_expense\")",
      "sourceExpressions": {
        "period_fy2022": "=B8-B14-B18",
        "period_fy2023": "=C8-C14-C18",
        "period_fy2024": "=D8-D14-D18",
        "period_fy2025": "=E8-E14-E18",
        "period_fy2026": "=F8-F14-F18"
      },
      "status": "supported"
    }
  ],
  "relationships": [
    {
      "id": "relationship_northstar_subscription_component",
      "fromId": "metric_northstar_subscription_revenue",
      "type": "component_of",
      "toId": "metric_northstar_revenue"
    },
    {
      "id": "relationship_northstar_services_component",
      "fromId": "metric_northstar_services_revenue",
      "type": "component_of",
      "toId": "metric_northstar_revenue"
    },
    {
      "id": "relationship_harbor_interest_component",
      "fromId": "metric_harbor_net_interest_income",
      "type": "component_of",
      "toId": "metric_harbor_operating_income"
    },
    {
      "id": "relationship_harbor_non_interest_component",
      "fromId": "metric_harbor_non_interest_income",
      "type": "component_of",
      "toId": "metric_harbor_operating_income"
    },
    {
      "id": "relationship_northstar_evidence_supports",
      "fromId": "evidence_northstar_retention",
      "type": "supports",
      "toId": "assumption_northstar_subscription_growth"
    },
    {
      "id": "relationship_northstar_assumption_affects",
      "fromId": "assumption_northstar_subscription_growth",
      "type": "affects",
      "toId": "metric_northstar_subscription_revenue"
    },
    {
      "id": "relationship_northstar_decision_related",
      "fromId": "decision_northstar_fy2025_revenue",
      "type": "related_to",
      "toId": "assumption_northstar_subscription_growth"
    },
    {
      "id": "relationship_harbor_evidence_supports",
      "fromId": "evidence_harbor_provision",
      "type": "supports",
      "toId": "assumption_harbor_credit_cost"
    },
    {
      "id": "relationship_harbor_assumption_affects",
      "fromId": "assumption_harbor_credit_cost",
      "type": "affects",
      "toId": "metric_harbor_provision"
    }
  ],
  "sourceArtifacts": [
    {
      "id": "artifact_northstar_workbook",
      "type": "workbook",
      "title": "Northstar Cloud operating model (representative fixture)",
      "uri": "fixtures://northstar-cloud-model.xlsx",
      "contentHash": "sha256:a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1",
      "retrievedAt": "2025-03-15T09:00:00Z"
    },
    {
      "id": "artifact_northstar_notes",
      "type": "document",
      "title": "Northstar Cloud forecast notes (representative fixture)",
      "uri": "fixtures://northstar-cloud-notes.md",
      "contentHash": "sha256:b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2",
      "retrievedAt": "2025-03-15T09:01:00Z"
    },
    {
      "id": "artifact_harbor_workbook",
      "type": "workbook",
      "title": "Harbor National bank model (representative fixture)",
      "uri": "fixtures://harbor-national-model.xlsx",
      "contentHash": "sha256:c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3",
      "retrievedAt": "2025-03-15T09:05:00Z"
    },
    {
      "id": "artifact_harbor_notes",
      "type": "document",
      "title": "Harbor National provision notes (representative fixture)",
      "uri": "fixtures://harbor-national-notes.md",
      "contentHash": "sha256:d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4d4",
      "retrievedAt": "2025-03-15T09:06:00Z"
    }
  ],
  "provenanceContexts": [
    {
      "id": "provenance_context_1",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.99,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_2",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.99,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_3",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.96,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_4",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.96,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_5",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.96,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_6",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 1,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_7",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.94,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_8",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 1,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_9",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.94,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_10",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.95,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_11",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.95,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_12",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.9,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_13",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.9,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_14",
      "sourceArtifactId": "artifact_northstar_notes",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.99,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_15",
      "sourceArtifactId": "artifact_harbor_notes",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.99,
      "reviewStatus": "confirmed"
    },
    {
      "id": "provenance_context_16",
      "sourceArtifactId": "artifact_northstar_notes",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.76,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_17",
      "sourceArtifactId": "artifact_harbor_notes",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.71,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_18",
      "sourceArtifactId": "artifact_northstar_workbook",
      "extractionRunId": "run_northstar_2025_03_15",
      "confidence": 0.96,
      "reviewStatus": "unreviewed"
    },
    {
      "id": "provenance_context_19",
      "sourceArtifactId": "artifact_harbor_workbook",
      "extractionRunId": "run_harbor_2025_03_15",
      "confidence": 0.64,
      "reviewStatus": "unreviewed"
    }
  ],
  "provenanceRecords": [
    {
      "targetId": "model_northstar_cloud",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Cover",
        "range": "A1:F12"
      }
    },
    {
      "targetId": "model_harbor_national",
      "contextId": "provenance_context_2",
      "locator": {
        "sheet": "Cover",
        "range": "A1:F12"
      }
    },
    {
      "targetId": "entity_northstar_cloud",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Cover",
        "cell": "B3"
      }
    },
    {
      "targetId": "entity_harbor_national",
      "contextId": "provenance_context_2",
      "locator": {
        "sheet": "Cover",
        "cell": "B3"
      }
    },
    {
      "targetId": "metric_northstar_revenue",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A10"
      }
    },
    {
      "targetId": "metric_northstar_subscription_revenue",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A11"
      }
    },
    {
      "targetId": "metric_northstar_services_revenue",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A12"
      }
    },
    {
      "targetId": "metric_northstar_cost_of_revenue",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A16"
      }
    },
    {
      "targetId": "metric_northstar_gross_profit",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A18"
      }
    },
    {
      "targetId": "metric_northstar_gross_margin",
      "contextId": "provenance_context_3",
      "locator": {
        "sheet": "Model",
        "cell": "A19"
      }
    },
    {
      "targetId": "metric_harbor_operating_income",
      "contextId": "provenance_context_4",
      "locator": {
        "sheet": "Model",
        "cell": "A8"
      }
    },
    {
      "targetId": "metric_harbor_net_interest_income",
      "contextId": "provenance_context_4",
      "locator": {
        "sheet": "Model",
        "cell": "A9"
      }
    },
    {
      "targetId": "metric_harbor_non_interest_income",
      "contextId": "provenance_context_4",
      "locator": {
        "sheet": "Model",
        "cell": "A10"
      }
    },
    {
      "targetId": "metric_harbor_provision",
      "contextId": "provenance_context_5",
      "locator": {
        "sheet": "Model",
        "cell": "A14"
      }
    },
    {
      "targetId": "metric_harbor_non_interest_expense",
      "contextId": "provenance_context_4",
      "locator": {
        "sheet": "Model",
        "cell": "A18"
      }
    },
    {
      "targetId": "metric_harbor_pre_tax_income",
      "contextId": "provenance_context_4",
      "locator": {
        "sheet": "Model",
        "cell": "A21"
      }
    },
    {
      "targetId": "period_fy2022",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Model",
        "range": "B7:F7"
      }
    },
    {
      "targetId": "period_fy2023",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Model",
        "range": "B7:F7"
      }
    },
    {
      "targetId": "period_fy2024",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Model",
        "range": "B7:F7"
      }
    },
    {
      "targetId": "period_fy2025",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Model",
        "range": "B7:F7"
      }
    },
    {
      "targetId": "period_fy2026",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Model",
        "range": "B7:F7"
      }
    },
    {
      "targetId": "scenario_actual",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Assumptions",
        "range": "B2:C2"
      }
    },
    {
      "targetId": "scenario_base",
      "contextId": "provenance_context_1",
      "locator": {
        "sheet": "Assumptions",
        "range": "B2:C2"
      }
    },
    {
      "targetId": "obs_northstar_revenue_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B10"
      }
    },
    {
      "targetId": "obs_northstar_revenue_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C10"
      }
    },
    {
      "targetId": "obs_northstar_revenue_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D10"
      }
    },
    {
      "targetId": "obs_northstar_revenue_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E10"
      }
    },
    {
      "targetId": "obs_northstar_revenue_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F10"
      }
    },
    {
      "targetId": "obs_northstar_subscription_revenue_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B11"
      }
    },
    {
      "targetId": "obs_northstar_subscription_revenue_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C11"
      }
    },
    {
      "targetId": "obs_northstar_subscription_revenue_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D11"
      }
    },
    {
      "targetId": "obs_northstar_subscription_revenue_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E11"
      }
    },
    {
      "targetId": "obs_northstar_subscription_revenue_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F11"
      }
    },
    {
      "targetId": "obs_northstar_services_revenue_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B12"
      }
    },
    {
      "targetId": "obs_northstar_services_revenue_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C12"
      }
    },
    {
      "targetId": "obs_northstar_services_revenue_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D12"
      }
    },
    {
      "targetId": "obs_northstar_services_revenue_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E12"
      }
    },
    {
      "targetId": "obs_northstar_services_revenue_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F12"
      }
    },
    {
      "targetId": "obs_northstar_cost_of_revenue_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B16"
      }
    },
    {
      "targetId": "obs_northstar_cost_of_revenue_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C16"
      }
    },
    {
      "targetId": "obs_northstar_cost_of_revenue_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D16"
      }
    },
    {
      "targetId": "obs_northstar_cost_of_revenue_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E16"
      }
    },
    {
      "targetId": "obs_northstar_cost_of_revenue_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F16"
      }
    },
    {
      "targetId": "obs_northstar_gross_profit_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B18"
      }
    },
    {
      "targetId": "obs_northstar_gross_profit_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C18"
      }
    },
    {
      "targetId": "obs_northstar_gross_profit_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D18"
      }
    },
    {
      "targetId": "obs_northstar_gross_profit_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E18"
      }
    },
    {
      "targetId": "obs_northstar_gross_profit_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F18"
      }
    },
    {
      "targetId": "obs_northstar_gross_margin_fy2022",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "B19"
      }
    },
    {
      "targetId": "obs_northstar_gross_margin_fy2023",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "C19"
      }
    },
    {
      "targetId": "obs_northstar_gross_margin_fy2024",
      "contextId": "provenance_context_6",
      "locator": {
        "sheet": "Model",
        "cell": "D19"
      }
    },
    {
      "targetId": "obs_northstar_gross_margin_fy2025",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "E19"
      }
    },
    {
      "targetId": "obs_northstar_gross_margin_fy2026",
      "contextId": "provenance_context_7",
      "locator": {
        "sheet": "Model",
        "cell": "F19"
      }
    },
    {
      "targetId": "obs_harbor_operating_income_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B8"
      }
    },
    {
      "targetId": "obs_harbor_operating_income_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C8"
      }
    },
    {
      "targetId": "obs_harbor_operating_income_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D8"
      }
    },
    {
      "targetId": "obs_harbor_operating_income_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E8"
      }
    },
    {
      "targetId": "obs_harbor_operating_income_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F8"
      }
    },
    {
      "targetId": "obs_harbor_net_interest_income_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B9"
      }
    },
    {
      "targetId": "obs_harbor_net_interest_income_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C9"
      }
    },
    {
      "targetId": "obs_harbor_net_interest_income_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D9"
      }
    },
    {
      "targetId": "obs_harbor_net_interest_income_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E9"
      }
    },
    {
      "targetId": "obs_harbor_net_interest_income_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F9"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_income_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B10"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_income_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C10"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_income_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D10"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_income_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E10"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_income_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F10"
      }
    },
    {
      "targetId": "obs_harbor_provision_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B14"
      }
    },
    {
      "targetId": "obs_harbor_provision_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C14"
      }
    },
    {
      "targetId": "obs_harbor_provision_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D14"
      }
    },
    {
      "targetId": "obs_harbor_provision_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E14"
      }
    },
    {
      "targetId": "obs_harbor_provision_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F14"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_expense_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B18"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_expense_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C18"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_expense_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D18"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_expense_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E18"
      }
    },
    {
      "targetId": "obs_harbor_non_interest_expense_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F18"
      }
    },
    {
      "targetId": "obs_harbor_pre_tax_income_fy2022",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "B21"
      }
    },
    {
      "targetId": "obs_harbor_pre_tax_income_fy2023",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "C21"
      }
    },
    {
      "targetId": "obs_harbor_pre_tax_income_fy2024",
      "contextId": "provenance_context_8",
      "locator": {
        "sheet": "Model",
        "cell": "D21"
      }
    },
    {
      "targetId": "obs_harbor_pre_tax_income_fy2025",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "E21"
      }
    },
    {
      "targetId": "obs_harbor_pre_tax_income_fy2026",
      "contextId": "provenance_context_9",
      "locator": {
        "sheet": "Model",
        "cell": "F21"
      }
    },
    {
      "targetId": "transformation_northstar_revenue",
      "contextId": "provenance_context_10",
      "locator": {
        "sheet": "Model",
        "range": "B10:F10"
      }
    },
    {
      "targetId": "transformation_northstar_gross_profit",
      "contextId": "provenance_context_10",
      "locator": {
        "sheet": "Model",
        "range": "B18:F18"
      }
    },
    {
      "targetId": "transformation_northstar_gross_margin",
      "contextId": "provenance_context_10",
      "locator": {
        "sheet": "Model",
        "range": "B19:F19"
      }
    },
    {
      "targetId": "transformation_harbor_operating_income",
      "contextId": "provenance_context_11",
      "locator": {
        "sheet": "Model",
        "range": "B8:F8"
      }
    },
    {
      "targetId": "transformation_harbor_pre_tax_income",
      "contextId": "provenance_context_11",
      "locator": {
        "sheet": "Model",
        "range": "B21:F21"
      }
    },
    {
      "targetId": "relationship_northstar_subscription_component",
      "contextId": "provenance_context_12",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_northstar_services_component",
      "contextId": "provenance_context_12",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_harbor_interest_component",
      "contextId": "provenance_context_13",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_harbor_non_interest_component",
      "contextId": "provenance_context_13",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_northstar_evidence_supports",
      "contextId": "provenance_context_12",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_northstar_assumption_affects",
      "contextId": "provenance_context_12",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_northstar_decision_related",
      "contextId": "provenance_context_12",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_harbor_evidence_supports",
      "contextId": "provenance_context_13",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "relationship_harbor_assumption_affects",
      "contextId": "provenance_context_13",
      "locator": {
        "sheet": "Model",
        "range": "A1:F30"
      }
    },
    {
      "targetId": "evidence_northstar_retention",
      "contextId": "provenance_context_14",
      "locator": {
        "passage": "Renewal cohort remains stable; base case assumes subscription growth moderates through FY26."
      }
    },
    {
      "targetId": "evidence_harbor_provision",
      "contextId": "provenance_context_15",
      "locator": {
        "passage": "Provision normalization is delayed to preserve coverage while criticized assets remain elevated."
      }
    },
    {
      "targetId": "assumption_northstar_subscription_growth",
      "contextId": "provenance_context_16",
      "locator": {
        "passage": "Subscription revenue growth moderates while renewal behavior remains stable."
      }
    },
    {
      "targetId": "assumption_harbor_credit_cost",
      "contextId": "provenance_context_17",
      "locator": {
        "passage": "Credit costs stay above the pre-cycle level through FY26."
      }
    },
    {
      "targetId": "decision_northstar_fy2025_revenue",
      "contextId": "provenance_context_14",
      "locator": {
        "passage": "Raise FY25 subscription revenue after reviewing renewal cohorts."
      }
    },
    {
      "targetId": "change_northstar_fy2025_subscription",
      "contextId": "provenance_context_18",
      "locator": {
        "sheet": "Model",
        "cell": "E11"
      }
    },
    {
      "targetId": "unresolved_harbor_provision_label",
      "contextId": "provenance_context_19",
      "locator": {
        "sheet": "Model",
        "cell": "A14"
      }
    }
  ],
  "evidence": [
    {
      "id": "evidence_northstar_retention",
      "sourceArtifactId": "artifact_northstar_notes",
      "excerpt": "Renewal cohort remains stable; base case assumes subscription growth moderates through FY26.",
      "observedAt": "2025-03-15T08:45:00Z"
    },
    {
      "id": "evidence_harbor_provision",
      "sourceArtifactId": "artifact_harbor_notes",
      "excerpt": "Provision normalization is delayed to preserve coverage while criticized assets remain elevated.",
      "observedAt": "2025-03-15T08:50:00Z"
    }
  ],
  "assumptions": [
    {
      "id": "assumption_northstar_subscription_growth",
      "modelId": "model_northstar_cloud",
      "statement": "Subscription revenue growth moderates while renewal behavior remains stable.",
      "entityId": "entity_northstar_cloud",
      "effectivePeriodIds": [
        "period_fy2025",
        "period_fy2026"
      ],
      "scenarioId": "scenario_base",
      "confidence": 0.76,
      "status": "active"
    },
    {
      "id": "assumption_harbor_credit_cost",
      "modelId": "model_harbor_national",
      "statement": "Credit costs stay above the pre-cycle level through FY26.",
      "entityId": "entity_harbor_national",
      "effectivePeriodIds": [
        "period_fy2025",
        "period_fy2026"
      ],
      "scenarioId": "scenario_base",
      "confidence": 0.71,
      "status": "active"
    }
  ],
  "decisions": [
    {
      "id": "decision_northstar_fy2025_revenue",
      "modelId": "model_northstar_cloud",
      "analystId": "analyst_demo",
      "createdAt": "2025-03-15T08:55:00Z",
      "rationaleText": "Raise FY25 subscription revenue after reviewing renewal cohorts.",
      "rationaleArtifactId": "artifact_northstar_notes"
    }
  ],
  "decisionChanges": [
    {
      "id": "change_northstar_fy2025_subscription",
      "decisionId": "decision_northstar_fy2025_revenue",
      "observationId": "obs_northstar_subscription_revenue_fy2025",
      "metricId": "metric_northstar_subscription_revenue",
      "periodId": "period_fy2025",
      "scenarioId": "scenario_base",
      "before": 1280,
      "after": 1315
    }
  ],
  "extractionRuns": [
    {
      "id": "run_northstar_2025_03_15",
      "sourceArtifactIds": [
        "artifact_northstar_workbook",
        "artifact_northstar_notes"
      ],
      "startedAt": "2025-03-15T09:00:00Z",
      "completedAt": "2025-03-15T09:02:00Z",
      "extractor": "fixture-extractor@0.1",
      "modelVersionId": "version_northstar_2025_03_15",
      "status": "completed",
      "notes": "Representative dataset for schema and viewer verification; not investment research."
    },
    {
      "id": "run_harbor_2025_03_15",
      "sourceArtifactIds": [
        "artifact_harbor_workbook",
        "artifact_harbor_notes"
      ],
      "startedAt": "2025-03-15T09:05:00Z",
      "completedAt": "2025-03-15T09:08:00Z",
      "extractor": "fixture-extractor@0.1",
      "modelVersionId": "version_harbor_2025_03_15",
      "status": "completed_with_issues",
      "notes": "One label-to-metric mapping remains explicitly unresolved."
    }
  ],
  "unresolvedItems": [
    {
      "id": "unresolved_harbor_provision_label",
      "modelId": "model_harbor_national",
      "category": "metric_mapping",
      "description": "The workbook label 'LLP' was mapped to provision for credit losses, but the source contains no explicit definition.",
      "currentTreatment": "The row is currently presented as Provision for credit losses.",
      "impact": "If LLP means something else, this row's semantic label and relationships are wrong; the source values are unchanged.",
      "nextAction": "Confirm that LLP means provision for credit losses at Model!A14.",
      "targetId": "metric_harbor_provision",
      "sourceArtifactId": "artifact_harbor_workbook",
      "locator": {
        "sheet": "Model",
        "cell": "A14"
      },
      "confidence": 0.64,
      "attentionLevel": "needs_review",
      "status": "open"
    }
  ],
  "tablePresentations": [
    {
      "modelId": "model_northstar_cloud",
      "sourceArtifactId": "artifact_northstar_workbook",
      "sections": [
        {
          "id": "section_northstar_revenue_build",
          "title": "Revenue build",
          "metricIds": [
            "metric_northstar_revenue",
            "metric_northstar_subscription_revenue",
            "metric_northstar_services_revenue"
          ],
          "sourceLocator": {
            "sheet": "Model",
            "range": "A10:F12"
          }
        },
        {
          "id": "section_northstar_gross_profit",
          "title": "Gross profit",
          "metricIds": [
            "metric_northstar_cost_of_revenue",
            "metric_northstar_gross_profit",
            "metric_northstar_gross_margin"
          ],
          "sourceLocator": {
            "sheet": "Model",
            "range": "A16:F19"
          }
        }
      ]
    },
    {
      "modelId": "model_harbor_national",
      "sourceArtifactId": "artifact_harbor_workbook",
      "sections": [
        {
          "id": "section_harbor_operating_income",
          "title": "Operating income",
          "metricIds": [
            "metric_harbor_operating_income",
            "metric_harbor_net_interest_income",
            "metric_harbor_non_interest_income"
          ],
          "sourceLocator": {
            "sheet": "Model",
            "range": "A8:F10"
          }
        },
        {
          "id": "section_harbor_credit_and_costs",
          "title": "Credit and costs",
          "metricIds": [
            "metric_harbor_provision",
            "metric_harbor_non_interest_expense"
          ],
          "sourceLocator": {
            "sheet": "Model",
            "range": "A14:F18"
          }
        },
        {
          "id": "section_harbor_pre_tax_earnings",
          "title": "Pre-tax earnings",
          "metricIds": [
            "metric_harbor_pre_tax_income"
          ],
          "sourceLocator": {
            "sheet": "Model",
            "range": "A21:F21"
          }
        }
      ]
    }
  ]
}
